import { useState } from 'react'
import { ImageOff } from 'lucide-react'
import { cn } from '@/lib/utils'

/** A product picture on white, or a quiet placeholder when there is none (demo `ProductAsset`). */
export function ProductImage({ url, alt, className }: { url?: string | null; alt: string; className?: string }) {
  const [failed, setFailed] = useState<string | null>(null)
  if (url && failed !== url) {
    return (
      <img
        alt={alt}
        className={cn('bg-white object-contain', className)}
        loading="lazy"
        onError={() => setFailed(url)}
        src={url}
      />
    )
  }
  return (
    <div
      aria-label={alt ? `No picture for ${alt}` : undefined}
      className={cn('grid place-items-center bg-muted text-muted-foreground', className)}
      role={alt ? 'img' : undefined}
    >
      <ImageOff aria-hidden="true" className="size-5" strokeWidth={1.5} />
    </div>
  )
}
